import { GoogleMap, InfoWindow, Marker, withGoogleMap } from 'react-google-maps';
import mapSyle from '../MapStyle';
import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { Device } from '../../@types/model/device';
import { PATH_DASHBOARD } from '../../routes/paths';
import { generatePath, useNavigate } from 'react-router-dom';
import { checkRoles, ROLE_END_USER, ROLE_USER } from 'guards/CheckRoles';
import { RootState, useSelector } from '../../redux/store';

const iconNormal = {
  url: '/static/icons/giraf/normal_marker.svg'
};
const iconAlert = {
  url: '/static/icons/giraf/alarm_marker.svg'
};
// const DonutGreen = {
//   url: '/static/donut_green.png'
// };
// const DonutYellow = {
//   url: '/static/donut_yellow.png'
// };
// const DonutRed = {
//   url: '/static/donut_red.png'
// };

const Deposito1 = {
  url: '/static/deposito1peq.png'
};
const Deposito2 = {
  url: '/static/deposito2peq.png'
};
const Deposito3 = {
  url: '/static/deposito3peq.png'
};
const Deposito4 = {
  url: '/static/deposito4peq.png'
};
const Deposito5 = {
  url: '/static/deposito5peq.png'
};

const Map = withGoogleMap((props: any) => {
  const { user } = useSelector((state: RootState) => state.user);
  const markers: any[] = [];
  const navigate = useNavigate();

  // @ts-ignore
  const bounds = new window.google.maps.LatLngBounds();

  const [userInteraction, setUserInteraction] = useState<{
    hovered: string | null;
    interacted: boolean;
  }>({
    hovered: null,
    interacted: false
  });

  // props.markers.forEach((device: Device) => {
  //   if (device.attributes.last_location !== null) {
  //     let icon = iconNormal;
  //     device.attributes.alarm_states.forEach((s: any) => {
  //       if (s.state === 'alarm') {
  //         icon = iconAlert;
  //       }
  //     });

  //     markers.push(
  //       <Marker
  //         onMouseOver={() =>
  //           setUserInteraction({
  //             hovered: device.guid,
  //             interacted: true
  //           })
  //         }
  //         onMouseOut={() =>
  //           setUserInteraction({
  //             hovered: null,
  //             interacted: true
  //           })
  //         }
  //         key={device.guid}
  //         position={{
  //           lat: device.attributes.last_location.lat,
  //           lng: device.attributes.last_location.lon
  //         }}
  //         onClick={() => {
  //           document.location.href = generatePath(PATH_DASHBOARD.devices.details, {
  //             guid: device.guid
  //           });
  //         }}
  //         icon={icon}
  //       >
  //         {userInteraction.hovered === device.guid ? (
  //           <InfoWindow options={{ disableAutoPan: true, disableAutoZoom: true }}>
  //             <span>
  //               {device.attributes.name.length > 0
  //                 ? device.attributes.name
  //                 : device.attributes.identifier}
  //             </span>
  //           </InfoWindow>
  //         ) : null}
  //       </Marker>
  //     );

  //     const { lat, lon } = device.attributes.last_location;
  //     // @ts-ignore
  //     const latLng = new window.google.maps.LatLng(lat, lon);
  //     bounds.extend(latLng);
  //   }
  // });

  props.markers.forEach((device: Device) => {
    if (device.attributes.last_location !== null) {
      let icon = iconNormal;
      device.attributes.alarm_states.forEach((s: any) => {
        if (s.state === 'alarm') {
          icon = iconAlert;
        }
      });
      let percent: number = 0;
      device.attributes.last_data?.data.forEach((dat) => {
        switch (dat.name) {
          case 'Percent':
            percent = parseInt(dat.value);
            break;
        }
      });

      if (percent > 90) icon = Deposito5;
      else if (percent > 60) icon = Deposito4;
      else if (percent > 30) icon = Deposito3;
      else if (percent > 15) icon = Deposito2;
      else if (percent <= 15) icon = Deposito1;

      markers.push(
        <Marker
          onMouseOver={() =>
            setUserInteraction({
              hovered: device.guid,
              interacted: true
            })
          }
          onMouseOut={() =>
            setUserInteraction({
              hovered: null,
              interacted: true
            })
          }
          key={device.guid}
          position={{
            lat: device.attributes.last_location.lat,
            lng: device.attributes.last_location.lon
          }}
          onClick={() => {
            if (checkRoles(user, ROLE_USER)) {
              navigate(
                generatePath(PATH_DASHBOARD.devices.details, {
                  guid: device.guid
                })
              );
            }
            if (checkRoles(user, ROLE_END_USER)) {
              navigate(
                generatePath(PATH_DASHBOARD.end_user.devices.details, {
                  guid: device.guid
                })
              );
            }
          }}
          icon={icon}
        >
          {userInteraction.hovered === device.guid ? (
            <InfoWindow options={{ disableAutoPan: true, disableAutoZoom: true }}>
              <span>
                {device.attributes.name.length > 0
                  ? device.attributes.name
                  : device.attributes.identifier}
              </span>
            </InfoWindow>
          ) : null}
        </Marker>
      );

      const { lat, lon } = device.attributes.last_location;
      // @ts-ignore
      const latLng = new window.google.maps.LatLng(lat, lon);
      bounds.extend(latLng);
    }
  });

  return (
    <GoogleMap
      ref={(map) => {
        map && !userInteraction.interacted && map.fitBounds(bounds);
      }}
      defaultZoom={8}
      defaultCenter={{ lat: 40.4169364687919, lng: -3.7035147827856765 }}
      options={{
        streetViewControl: false,
        mapTypeControlOptions: {
          mapTypeIds: ['roadmap', 'satellite']
        },
        fullscreenControl: false,
        styles: mapSyle
      }}
    >
      {markers}
    </GoogleMap>
  );
});

export interface DevicesMapProps {
  height: number;
  devices: Device[];
}

export const DevicesMapRepsolB2B: React.FC<DevicesMapProps> = (props: DevicesMapProps) => {
  const [devices, setDevices] = useState<Device[]>([]);

  useEffect(() => {
    setDevices(props.devices);
    /*getDevices(
      0,
      10000,
      (data: Device[], count: number) => {
        setDevices(data);
      },
      false,
      null
    );*/
  }, [props.devices]);

  return (
    <Box mt={'15px'} mb={'30px'}>
      <Map
        // tslint:disable-next-line
        isMarkerShown
        googleMapURL="https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places"
        loadingElement={<div style={{ height: `100%` }} />}
        containerElement={<div style={{ height: props.height ? props.height : `800px` }} />}
        mapElement={<div style={{ height: `100%` }} />}
        markers={devices}
      />
    </Box>
  );
};
